import React, { ReactNode } from 'react';
import { BookingSlot } from '../../types/booking';
import { FormattedMessage } from 'react-intl';

type SlotStyle = {
  readonly color: string;
  readonly textColor: string;
  readonly cursor: 'pointer' | 'not-allowed';
  readonly legend: ReactNode;
  readonly label: ReactNode;
};

type SlotStyles = {
  readonly [K in BookingSlot['status']]: SlotStyle;
};

export const SLOT_STYLES: SlotStyles = {
  available: {
    color: '#83D2A3', // Green - available for booking
    textColor: '#333',
    cursor: 'pointer',
    legend: <FormattedMessage defaultMessage="Ledig att boka" />,
    label: <FormattedMessage defaultMessage="Tillgänglig" />,
  },
  taken: {
    color: '#FDCE8D', // Yellow - booked by others
    textColor: '#333',
    cursor: 'not-allowed',
    legend: <FormattedMessage defaultMessage="Upptagen" />,
    label: <FormattedMessage defaultMessage="Upptagen" />,
  },
  userBooked: {
    color: '#3B3EC6', // Blue - user's bookings
    textColor: '#fff',
    cursor: 'pointer',
    legend: <FormattedMessage defaultMessage="Dina bokningar" />,
    label: <FormattedMessage defaultMessage="Din bokning" />,
  },
  past: {
    color: '#E5E7EB', // Gray - unavailable slots
    textColor: '#666',
    cursor: 'not-allowed',
    legend: <FormattedMessage defaultMessage="Ej tillgänglig" />,
    label: <FormattedMessage defaultMessage="Ej tillgänglig" />,
  },
} as const;
